module.exports = __webpack_public_path__ + "img/tucan-2.0e5822bd.png";